import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container-x py-28 text-center">
      <div className="overline text-terracotta">404</div>
      <div className="mt-3 font-serif text-5xl">This page has checked out.</div>
      <Link to="/" className="btn-ghost mt-8 inline-flex">Return home</Link>
    </div>
  );
}
